// extracted by mini-css-extract-plugin
export default {"continuebutton":"continuebutton_continuebutton__HT2K4"};